import { useRef } from "react"
import { fixCommissionInputTranslations } from "../utils/commission-rules-data"


export const FixCommissionInput = ({name, title, value, onChange}) => {

    const container = useRef(null)

    const forwardEvent = (key, commissions) => {

        onChange({name, value: {...value, [key]: commissions}})
    }

    return (
        <div className="fix-commission-input-container" ref={container}>
            <div className="fix-commission-input-top">
                <p className="label">{title}</p>
                <button 
                    type="button" 
                    className="icon-button"
                    onClick={e => container.current.classList.toggle('open')}
                >
                    <span className="ti ti-chevron-down"></span>
                </button>
            </div>
            <div className="fix-commission-input-bottom">
                <ul className="fix-commission-input-ul">
                <li
                    className="fix-commission-input-li"
                >
                    <p></p>
                    <div className="fix-commission-input-li-commissions-container">
                        <input 
                            type="text" 
                            id={`${name}-sample-absolute`}
                            className="fix-commission-li-input"
                            value={"€"} 
                            min={0}
                            onChange={() => {}}
                            />
                        <input 
                            type="text" 
                            id={`${name}-sample-percentage`}
                            className="fix-commission-li-input"
                            value={"%"}
                            max={100}
                            onChange={() => {}}
                        />
                    </div>
                </li>
                {
                    Object.entries(value).map(([key, value]) => {

                        const [absolute, percentage] = value

                        return (
                            <li
                                key={key}
                                className="fix-commission-input-li"
                            >
                                <p>{fixCommissionInputTranslations[name]?.[key] || key}</p>
                                <div className="fix-commission-input-li-commissions-container">
                                    <input 
                                        type="number" 
                                        id={`${name}-${key}-absolute`}
                                        className="fix-commission-li-input"
                                        value={absolute} min={0}
                                        onChange={e => forwardEvent(key, [Number(e.target.value || 0), percentage])}
                                        />
                                    <input 
                                        type="number" 
                                        id={`${name}-${key}-percentage`}
                                        className="fix-commission-li-input"
                                        value={percentage * 100} min={0} 
                                        max={100} 
                                        onChange={e => forwardEvent(key, [absolute, Number(e.target.value || 0) / 100])}
                                    />
                                </div>
                            </li>
                        )
                    })
                }
                </ul>
            </div>
        </div>
    )
}